import { axiosInstance } from '@/modules/shared/lib/axios'
import { AddCompaniesToGroupRequest } from './types'

type Props = {
  companyId: string
  payload: AddCompaniesToGroupRequest
}

export function addCompaniesToGroup({ companyId, payload }: Props) {
  return axiosInstance.post(
    `/config-api/${companyId}/configuration/admin/companies/addCompaniesToGroup`,
    payload
  )
}
